/**
 * Szerokosc ekranu prezentacji — ustawienie trwale, per przegladarka.
 *
 * Ekran publiczny domyslnie trzyma tresc w kolumnie `max-w-[110rem]`, zeby na
 * zwyklym monitorze linie nie byly za dlugie. Na duzym wyswietlaczu ta kolumna
 * zostawia szerokie marginesy po bokach, a os czasu kortow niepotrzebnie
 * przewija sie w poziomie — tryb pelnoekranowy zdejmuje ograniczenie i oddaje
 * tresci cala szerokosc.
 *
 * Wybor zapisujemy w `localStorage`, bo wyswietlacz w klubie ustawia sie raz
 * i ma przetrwac przeladowanie strony.
 */

/** Klucz ustawienia w `localStorage`. */
export const PUBLIC_SCREEN_WIDE_STORAGE_KEY = 'tenify.publicScreen.wide';

/** Wartosc zapisywana przy wlaczonym trybie pelnoekranowym. */
const ENABLED = '1';

/**
 * Odczytuje zapisany tryb szerokosci. Domyslnie `false` — tryb pelnoekranowy
 * wlacza sie wylacznie swiadomym kliknieciem, nigdy sam.
 */
export function readStoredWideMode(): boolean {
  try {
    return localStorage.getItem(PUBLIC_SCREEN_WIDE_STORAGE_KEY) === ENABLED;
  } catch {
    // Tryb prywatny albo zablokowane dane witryny — zostaje szerokosc domyslna.
    return false;
  }
}

/** Zapisuje tryb szerokosci. Wylaczenie czysci wpis, zeby nie zostawiac smieci. */
export function storeWideMode(wide: boolean): void {
  try {
    if (wide) {
      localStorage.setItem(PUBLIC_SCREEN_WIDE_STORAGE_KEY, ENABLED);
    } else {
      localStorage.removeItem(PUBLIC_SCREEN_WIDE_STORAGE_KEY);
    }
  } catch {
    // Brak dostepu do storage nie moze wywrocic ekranu prezentacji.
  }
}
